import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../../models/IDropdown";
import { useForm } from "react-hook-form";
import { Fetch } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { Button } from "primereact/button";
import { EmptyFilter } from "./Table";
import { JVInput } from "../../../shared/JVInput";

export interface IFilter {
    client_Category_ID: number | null,
    service_Department: string | null
}

interface IProps {
    filters: IFilter,
    setFilters: (filters: IFilter) => void,
    loading: boolean,
}

interface IRFPClientCategory {
    id?: number,
    category_Name?: string,
    description?: string,
    added_By?: string,
    added_On?: Date,
    isActive?: boolean,
    updated_By?: string,
    updated_On?: Date,
}

const schema = yup.object({
    client_Category_ID: yup.number().nullable(),
    service_Department: yup.string().nullable(),
});

export const Filter = (props: IProps) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [categories, setCategories] = useState<Array<IRFPClientCategory>>([]);
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadCategories = async () => {
        const response = await Fetch("Tender_Client_Category/GetAllTenderClientCategory", "GET", null, null, null);
        if (response) {
            const data: Array<IRFPClientCategory> = await response.json();
            const emptyData = {
                id: 0,
                category_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCategories(data);
        }
    }



    useEffect(() => {
        loadCompanies();
        loadBranches();
        loadCategories();
    }, []);

    // useEffect(() => {
    //     const subscription = watch((value, { name, type }) => {
    //         if (name === "company") {
    //             if (value.company != 0 && value.company != null) {
    //                 loadBranches(value.company);
    //             } else {
    //                 loadBranches();
    //             }
    //         }
    //     });

    //     return () => subscription.unsubscribe();
    // }, [watch]);

    const onSubmit = (data: IFilter) => {
        props.setFilters(data);
    }

    const handleClear = () => {
    reset(EmptyFilter);
    props.setFilters(EmptyFilter);
};

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            {/* <JVDropdown column={6} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
            <JVDropdown column={6} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" /> */}
            <JVDropdown column={6} control={control} label="Category" name="client_Category_ID" options={categories} optionLabel="category_Name" optionValue="id" placeholder="Select Category" />
            {/* <JVInput column={3} required label="Service Department" control={control} name="service_Department" error={errors.service_Department?.message} /> */}
            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading}></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={handleClear} type="button"></Button>
            </div>
        </form>
    );
}